module.exports = __webpack_public_path__ + "assets/0a82d648e00573a4f74949a2b96469bf.mp3";